import * as React from 'react'

const AccessRight = ({ user }) => {
  const renderFlag = (bool) =>
    bool ? (
      <i className="fas fa-check" style={{ color: 'green' }}></i>
    ) : (
      <i className="fas fa-times" style={{ color: 'red' }}></i>
    )

  return (
    <>
      <div className="mt-3">Event Access Rights:</div>
      <div className="card d-flex flex-column mt-2 p-4 w-100">
        <div className="d-flex flex-column gap-3">
          {/* {user.eventAccess?.map((event, index) => (
            <div key={index}>
              <span className="fw-bold">{`${event}: `}</span>
              {renderFlag(event)}
            </div>
          ))} */}
          <div>
            <span className="fw-bold">Congress Ticket: </span>
            {renderFlag(user.accessMain)}
          </div>

          <div>
            <span className="fw-bold">CCNDP Post Congress Workshop: </span>
            {renderFlag(user.accessCcndp)}
          </div>

          <div>
            <span className="fw-bold">UPM Pre-Congress Workshop: </span>
            {renderFlag(user.accessUpm)}
          </div>

          <div>
            <span className="fw-bold">GP Track: </span>
            {renderFlag(user.accessGp)}
          </div>
        </div>
      </div>
    </>
  )
}

export default AccessRight
